import styled from 'styled-components'
import { cores } from '../../styles'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  button {
    width: 350px;
  }

  form {
    width: 100px;
  }
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  width: 350px;
  height: 350px;
  padding: 12px;
  border: 1px solid ${cores.cinza};
  border-radius: 6px;
  background-size: cover;
  transition: all ease 0.3s;

  h2 {
    font-weight: 400;
    color: ${cores.azul};
  }

  input,
  textarea {
    padding: 6px;
    border: 1px solid ${cores.cinza};
    border-radius: 6px;
    font-size: 16px;
    resize: none;
  }

  &.download {
    justify-content: end;

    p {
      padding: 10px;
      margin: 0 20px;
      background-color: ${cores.laranjaEscuro};
      border-radius: 6px;
      color: ${cores.branco};
      text-align: center;
    }
  }

  &:hover {
    scale: 1.01;
    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25);
  }
`
